import React from 'react';
import {documentTypes} from '../../../../../../../util/uiconstants';
import ProfileFooter from './ProfileFooter';
import IndependenceTemplateFooter from './IndependenceTemplateFooter';
import IndivualIndependenceFooter from './Independence/IndivualIndependenceFooter';

const individualIndependenceFooter = (props) => {
	return <IndivualIndependenceFooter {...props} />;
};

const independenceTemplateFooter = (props) => {
	return <IndependenceTemplateFooter {...props} />;
};

const profileFooter = (props) => {
	return <ProfileFooter {...props} />;
};

const footerConfig = {
	[documentTypes.INDEPENDENCEFORMINDIVIDUAL]: {
		render: individualIndependenceFooter
	},
	[documentTypes.INDEPENDENCEFORMTEMPLATE]: {
		render: independenceTemplateFooter
	},
	[documentTypes.PROFILEV2]: {
		render: profileFooter
	}
};

export function getFooterConfig(documentTypeId, footerProps) {
	const _footerConfig = footerConfig[documentTypeId];

	return _footerConfig?.render(footerProps);
}
